export default "__VITE_ASSET__DudAV1E0__"